import { ToastContainer } from "react-toastify";
import { Outlet } from "react-router-dom";
import Sidebar from "./Navbar/Sidebar";
import TopNavBar from "./Navbar/TopNavBar";
import { useState } from "react";
import LogoLoader from "./Spinner/logoLoader";
import { useEffect } from "react";

const Layout = () => {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [pageTitle, setPageTitle] = useState("");

  const [isLoading, setIsLoading] = useState(false); // << Add this here

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        // Mobile & tablet
        setIsSidebarVisible(false);
      } else {
        // Desktop
        setIsSidebarVisible(true);
      }
    };

    handleResize(); // run once on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarVisible((prev) => !prev);
  };

  
  
  return (
    <div className="layout-container d-flex min-vh-100 bg-dark">
      {/* Sidebar */}
      <Sidebar isVisible={isSidebarVisible} onForceToggle={toggleSidebar} />

      {/* Main content */}
      <main
        className={`main-content flex-grow-1 d-flex flex-column mt-0 border-radius-lg bg-wrapper ${
          isSidebarVisible ? "with-sidebar" : "sidebar-collapsed"
        }`}
       
      >
        <TopNavBar
          currentpage={pageTitle}
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />

        <div className="container-fluid py-0 px-0 ">

          {isLoading && <LogoLoader />}
          <Outlet
            context={{
              setPageTitle,
              setTable_Loading: setIsLoading,
            }}
          />
        </div>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
      </main>
    </div>
  );
};

export default Layout;
